const firebaseConfig = {
  apiKey: "AIzaSyD_zkM_7-HUDDWRAmE-wlqYpMY84LOHLUI",
  authDomain: "volunteer-547ac.firebaseapp.com",
  databaseURL: "https://volunteer-547ac.firebaseio.com",
  projectId: "volunteer-547ac",
  storageBucket: "volunteer-547ac.appspot.com",
  messagingSenderId: "609668134668",
  appId: "1:609668134668:web:c544cbdb06ed3a3407bb29"
};
export default firebaseConfig;